import React, {Component} from 'react';
import Chart from 'react-apexcharts';
import MUIDataTable from "mui-datatables";
import {Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';

class KioskDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            baseUrl: localStorage.getItem("API_URL"),
            token: localStorage.getItem("user_token"),

            overallStats: {
                totalFeedbacks: 0,
                todayFeedbacks: 0,
                avgRating: 0,
                maxScore: 5,
                kioskCount: 0
            },

            kioskSummaries: [],

            barChartOptions: {
                chart: {id: "kiosk-ratings", toolbar: {show: false}},
                xaxis: {categories: []},
                title: {
                    text: "User Wise Average Rating",
                    align: 'left',
                    style: {color: '#ffffff'}
                },
                colors: ['#00c4ff'],
                plotOptions: {
                    bar: {borderRadius: 4}
                },
                yaxis: {
                    min: 0,
                    labels: {formatter: (val) => val.toFixed(1)}
                }
            },
            barChartSeries: [{name: "Avg Rating", data: []}],

            donutChartOptions: {
                labels: [],
                title: {
                    text: "Feedback Distribution",
                    align: 'left',
                    style: {color: '#ffffff'}
                },
                colors: ['#28a745', '#a8f29aff', '#e6d08cff', '#ffc107', '#f59607ff', '#ff605bff', '#ff5207ff', '#fd1414ff', '#c1a8a7ff', '#686868ff'],
                tooltip: {
                    y: {
                        formatter: (value) => {
                            const series = this.state.donutChartSeries;
                            const total = series.reduce((a, b) => Number(a) + Number(b), 0);
                            const percent = total === 0 ? 0 : ((Number(value) / total) * 100).toFixed(1);
                            return `${percent}%`;
                        }
                    }
                }
            },
            donutChartSeries: [],

            showModal: false,
            modalData: [],
            isModalLoading: false,
            selectedKioskName: "",
            selectedAnswerRating: 0,

            page: 0,
            size: 10,
            searchText: "",
            totalRows: 0,
            tableData: [],

            tableColumns: [
                {name: "branchName", label: "Branch"},
                {name: "kioskName", label: "User"},
                {name: "givenDate", label: "Date"},
                {name: "givenTime", label: "Time"},
                {name: "question", label: "Question"},
                {
                    name: "feedbackName",
                    label: "Feedback",
                    options: {
                        customBodyRender: (value, tableMeta) => {
                            const rowData = this.state.tableData[tableMeta.rowIndex];
                            const score = rowData ? rowData.feedbackScore : 0;
                            const scoreColor = score >= 4 ? '#28a745' : score >= 3 ? '#ffc107' : '#dc3545';
                            return (
                                <span>
                                    <span style={{color: scoreColor, fontWeight: '600'}}>{value}</span>
                                    <span style={{color: '#888', fontSize: '0.8em', marginLeft: '5px'}}>({score})</span>
                                </span>
                            );
                        }
                    }
                },
                {name: "mobileNo", label: "Mobile"},
                {
                    name: "Actions",
                    options: {
                        filter: false,
                        sort: false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => this.handleOpenModal(tableMeta.rowIndex)}
                                >
                                    View
                                </button>
                            );
                        }
                    }
                }
            ],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const {baseUrl, token, page, size, searchText} = this.state;

        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        let customerId = userDetails ? userDetails['cid'] : null;

        const requestPayload = {
            page,
            size,
            id: customerId,
            searchText: searchText || ""
        };

        axios({
            method: 'POST',
            url: `${baseUrl}/feedback/kiosk-dashboard`,
            headers: {Authorization: token},
            data: requestPayload
        })
            .then(res => {
                if (res.data && res.data.data) {
                    const data = res.data.data;

                    const overall = data.overallStats || {};
                    const kiosks = data.kioskSummaries || [];
                    const feedbackPage = data.feedbackList || {content: [], totalElements: 0};
                    const donut = data.donutData || [];

                    const barLabels = kiosks.map(k => k.kioskName || `User ${k.kioskId}`);
                    const barValues = kiosks.map(k => parseFloat((k.avgRating || 0).toFixed(2)));

                    const donutLabels = donut.map(d => d.feedback);
                    const donutSeries = donut.map(d => d.givenFeedbacks || 0);

                    const maxBarVal = Math.max(...barValues, overall.maxScore || 5);

                    this.setState({
                        overallStats: {
                            totalFeedbacks: overall.totalFeedbacks || 0,
                            todayFeedbacks: overall.todayFeedbacks || 0,
                            avgRating: overall.avgRating || 0,
                            maxScore: overall.maxScore || 5,
                            kioskCount: overall.kioskCount || 0
                        },
                        kioskSummaries: kiosks,
                        barChartOptions: {
                            ...this.state.barChartOptions,
                            xaxis: {categories: barLabels},
                            yaxis: {
                                min: 0,
                                max: maxBarVal,
                                labels: {formatter: (val) => parseFloat(val).toFixed(1)}
                            }
                        },
                        barChartSeries: [{name: "Avg Rating", data: barValues}],
                        donutChartOptions: {...this.state.donutChartOptions, labels: donutLabels},
                        donutChartSeries: donutSeries,
                        tableData: feedbackPage.content || [],
                        totalRows: feedbackPage.totalElements || 0
                    });
                }
            })
            .catch(err => {
                console.error("Error fetching kiosk dashboard data:", err);
                toast.error("Failed to load kiosk dashboard", {position: "bottom-center"});
            });
    }

    handleTableChange = (action, tableState) => {
        switch (action) {
            case 'changePage':
                this.setState({page: tableState.page}, () => this.fetchData());
                break;
            case 'changeRowsPerPage':
                this.setState({size: tableState.rowsPerPage, page: 0}, () => this.fetchData());
                break;
            case 'search':
                this.setState({searchText: tableState.searchText || "", page: 0}, () => this.fetchData());
                break;
            default:
                break;
        }
    }

    handleOpenModal = (rowIndex) => {
        const row = this.state.tableData[rowIndex];
        if (!row) return;

        const answerId = row.id;
        const kioskName = row.kioskName || "";
        const rating = row.feedbackScore || 0;

        this.setState({
            showModal: true,
            modalData: [],
            isModalLoading: true,
            selectedKioskName: kioskName,
            selectedAnswerRating: rating
        });

        const {baseUrl, token} = this.state;

        axios({
            method: 'GET',
            url: `${baseUrl}/feedback/Q&A/kiosk-answer/${answerId}`,
            headers: {Authorization: token}
        })
            .then(res => {
                if (res.data && res.data.data) {
                    this.setState({modalData: res.data.data, isModalLoading: false});
                } else {
                    this.setState({isModalLoading: false});
                }
            })
            .catch(err => {
                console.error("Error fetching feedback QA:", err);
                toast.error("Failed to load feedback details", {position: "bottom-center"});
                this.setState({isModalLoading: false});
            });
    }

    handleCloseModal = () => {
        this.setState({showModal: false});
    }

    renderStars = (rating, maxScore) => {
        const value = parseFloat(rating) || 0;
        const full = Math.floor(value);
        const half = value % 1 >= 0.5;
        const max = maxScore || 5;
        const empty = max - full - (half ? 1 : 0);

        return (
            <span style={{color: '#ffc107'}}>
                {[...Array(full)].map((_, i) => <i key={`f${i}`} className="fa fa-star"/>)}
                {half && <i className="fa fa-star-half-o"/>}
                {[...Array(Math.max(empty, 0))].map((_, i) => <i key={`e${i}`} className="fa fa-star-o"/>)}
                <span style={{color: '#666', fontSize: '0.85em', marginLeft: '5px'}}>
                    ({value.toFixed(1)}/{max})
                </span>
            </span>
        );
    }

    render() {
        const {
            overallStats,
            kioskSummaries,
            tableData,
            totalRows,
            page,
            size,
            modalData,
            isModalLoading,
            selectedKioskName,
            showModal
        } = this.state;

        const tableOptions = {
            filterType: 'checkbox',
            selectableRows: 'none',
            responsive: 'standard',
            serverSide: true,
            count: totalRows,
            page,
            rowsPerPage: size,
            rowsPerPageOptions: [5, 10, 20, 50],
            search: true,
            print: false,
            download: false,
            onTableChange: this.handleTableChange
        };

        return (
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-5 col-md-8 col-sm-12">
                            <h2>User Dashboard</h2>
                            <small className="text-muted">Device-wise feedback analytics</small>
                        </div>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="row clearfix">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <i className="fa fa-users fa-2x text-primary mb-2"/>
                                <h6>Total Users</h6>
                                <h3>{overallStats.kioskCount}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <i className="fa fa-comments fa-2x text-success mb-2"/>
                                <h6>Total Feedbacks</h6>
                                <h3>{overallStats.totalFeedbacks}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <i className="fa fa-calendar fa-2x text-info mb-2"/>
                                <h6>Today's Feedbacks</h6>
                                <h3>{overallStats.todayFeedbacks}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="card text-center">
                            <div className="body">
                                <i className="fa fa-star fa-2x text-warning mb-2"/>
                                <h6>Overall Avg. Rating</h6>
                                <h3>{this.renderStars(overallStats.avgRating, overallStats.maxScore)}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Charts */}
                <div className="row clearfix" style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div className="col-lg-8 col-md-12 col-sm-12" style={{display: 'flex'}}>
                        <div className="card" style={{flex: 1}}>
                            <div className="body">
                                <Chart
                                    options={this.state.barChartOptions}
                                    series={this.state.barChartSeries}
                                    type="bar"
                                    height="350"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12" style={{display: 'flex'}}>
                        <div className="card" style={{flex: 1}}>
                            <div className="body d-flex align-items-center justify-content-center">
                                <Chart
                                    options={this.state.donutChartOptions}
                                    series={this.state.donutChartSeries}
                                    type="donut"
                                    height="350"
                                    width="100%"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Kiosk Cards */}
                {kioskSummaries.length > 0 && (
                    <div className="row clearfix">
                        <div className="col-12">
                            <div className="card">
                                <div className="header">
                                    <h2>User Overview</h2>
                                </div>
                                <div className="body">
                                    <div className="row">
                                        {kioskSummaries.map((kiosk, idx) => {
                                            const avg = parseFloat(kiosk.avgRating || 0);
                                            const max = kiosk.maxScore || 5;
                                            const pct = max > 0 ? (avg / max) * 100 : 0;
                                            const barColor = pct >= 70 ? '#28a745' : pct >= 40 ? '#ffc107' : '#dc3545';

                                            return (
                                                <div key={idx} className="col-lg-3 col-md-4 col-sm-6">
                                                    <div className="card" style={{border: '1px solid #e0e0e0'}}>
                                                        <div className="body">
                                                            <div
                                                                className="d-flex justify-content-between align-items-start mb-2">
                                                                <div>
                                                                    <h6 className="mb-0" style={{fontWeight: '600'}}>
                                                                        {kiosk.kioskName || `User ${kiosk.kioskId}`}
                                                                    </h6>
                                                                    <small
                                                                        className="text-muted">{kiosk.branchName}</small>
                                                                </div>
                                                                <i className="fa fa-user fa-lg text-primary"/>
                                                            </div>

                                                            <div className="mb-1">
                                                                {this.renderStars(avg, max)}
                                                            </div>

                                                            <div className="progress mb-2" style={{height: '6px'}}>
                                                                <div
                                                                    className="progress-bar"
                                                                    style={{
                                                                        width: `${pct}%`,
                                                                        backgroundColor: barColor
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="d-flex justify-content-between">
                                                                <small>
                                                                    <i className="fa fa-comments text-muted mr-1"/>
                                                                    {kiosk.totalFeedbacks} total
                                                                </small>
                                                                <small>
                                                                    <i className="fa fa-clock-o text-muted mr-1"/>
                                                                    {kiosk.todayFeedbacks} today
                                                                </small>
                                                            </div>

                                                            {kiosk.lastFeedbackDate && (
                                                                <small className="text-muted d-block mt-1">
                                                                    Last: {kiosk.lastFeedbackDate}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Feedback List */}
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card">
                            <div className="body">
                                <MUIDataTable
                                    title={"Feedback List"}
                                    data={tableData}
                                    columns={this.state.tableColumns}
                                    options={tableOptions}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Q&A Modal */}
                <Modal show={showModal} onHide={this.handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Feedback Details {selectedKioskName ? `— User: ${selectedKioskName}` : ""}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isModalLoading ? (
                            <p>Loading details...</p>
                        ) : modalData && modalData.length > 0 ? (
                            modalData.map((qa, index) => (
                                <div key={index}>
                                    <h6><strong>Q: {qa.question}</strong></h6>
                                    <p>A: {qa.answer}</p>
                                    {index < modalData.length - 1 && <hr/>}
                                </div>
                            ))
                        ) : (
                            <p>No feedback details available.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default KioskDashboard;
